import React from "react";
import {WIZARD_GROUP_TYPES} from "../../../interfaces/wizardItemInterface";

export const getWizardStepWarningCheckMark = (wizardSelectedValue, featureGroup, cartItems, activeQuoteIndex,
  stepGroups, isIncompatibleModalOpened, wizardConflictingSteps, wizardConflictPopupOpened) => {

  const wizardGroup = stepGroups[0]; //wizardSelectedValue.wizardGroup.id
  if (!wizardGroup || (wizardGroup.nodeType !== WIZARD_GROUP_TYPES.group)) {
    return null
  }

  const isIncompatibleWizardGroup = wizardConflictingSteps?.find((wizardConflictingStep) => {
    return wizardConflictingStep.wizardGroupGroupName === wizardGroup.groupName
  })

  if ((isIncompatibleModalOpened || wizardConflictPopupOpened) && isIncompatibleWizardGroup) {
    return isIncompatibleWizardGroup
  }

  return null
}

const MaterialsWizardWarningCheckMark = ({className}) => {
  return (
    <div className={"selection-footer-list__item-warning selection-footer-list__item-done--svg"
      + (className ? " " + className : "")}>
    </div>
  )
};
export default MaterialsWizardWarningCheckMark
